import { render, staticRenderFns } from "./dashboard-bar-row.vue?vue&type=template&id=3c212f5c&scoped=true"
import script from "./dashboard-bar-row.vue?vue&type=script&lang=js"
export * from "./dashboard-bar-row.vue?vue&type=script&lang=js"
import style0 from "./dashboard-bar-row.vue?vue&type=style&index=0&id=3c212f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c212f5c",
  null
  
)

export default component.exports